"use strict";
// MA: Movement Allowance
// ST : Strength
// AG: Agility
// AV: Armour Value
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCareers = exports.getAvailableCareers = exports.RACE = exports.CAREER_VERSION = exports.CAREER_MIGRATION_2025 = exports.CAREER_IS_2025 = exports.CAREER_ID = exports.AVATAR_RARITY = exports.AVATAR = void 0;
const career2025_1 = require("./career2025");
const skill_1 = require("./skill");
var RACE;
(function (RACE) {
    RACE["AMAZON"] = "amazon-career";
    RACE["CHAOS_DWARF"] = "chaos-dwarf-career";
    RACE["CHAOS"] = "chaos-career";
    RACE["DARK_ELFE"] = "dark-elfe-career";
    RACE["DWARF"] = "dwarf-career";
    RACE["ELVEN_UNION"] = "elven-union-career";
    RACE["GOBELIN"] = "gobelin-career";
    RACE["HALFLING"] = "halfling-career";
    RACE["HUMAN"] = "human-career";
    RACE["IMPERIAL"] = "imperial-career";
    RACE["KHORNE"] = "khorne-career";
    RACE["LIZARDMEN"] = "lizardmen-career";
    RACE["NECROMANTIC"] = "necromantic-career";
    RACE["NORSE"] = "norse-career";
    RACE["NURGLE"] = "nurgle-career";
    RACE["ORC"] = "orc-career";
    RACE["RAT"] = "rat-career";
    RACE["SILVAN"] = "silvan-career";
    RACE["SNOTLING"] = "snotling-career";
    RACE["UNDEAD"] = "undead-career";
    RACE["VAMPIRE"] = "vampire-career";
    RACE["SLANN"] = "slann-career";
})(RACE || (exports.RACE = RACE = {}));
var AVATAR_RARITY;
(function (AVATAR_RARITY) {
    AVATAR_RARITY["COMMUN"] = "c";
    AVATAR_RARITY["RARE"] = "r";
    AVATAR_RARITY["UNIQUE"] = "u";
    AVATAR_RARITY["SEASONAL"] = "s";
})(AVATAR_RARITY || (exports.AVATAR_RARITY = AVATAR_RARITY = {}));
var AVATAR;
(function (AVATAR) {
    AVATAR["BEASTMAN"] = "beastman";
    AVATAR["BLACK_ORC"] = "black-orc";
    AVATAR["BLOATER"] = "bloater";
    AVATAR["BLOODSPAWN"] = "bloodspawn";
    AVATAR["CENTAUR"] = "centaur";
    AVATAR["CHAOS_DWARF"] = "chaos-dwarf";
    AVATAR["CHAOS_WARRIOR"] = "chaos-warrior";
    AVATAR["DARK_ELF"] = "dark_elf";
    AVATAR["DWARF"] = "dwarf";
    AVATAR["ELF"] = "elf";
    AVATAR["GOBELIN"] = "gobelin";
    AVATAR["GOLEM"] = "golem";
    AVATAR["HALFING"] = "halfing";
    AVATAR["HUMAN_WOMAN"] = "human-woman";
    AVATAR["HUMAN"] = "human";
    AVATAR["LIZARDMEN"] = "lezard";
    AVATAR["MINOTAUR"] = "minotaur";
    AVATAR["OGRE"] = "ogre";
    AVATAR["ORC"] = "orc";
    AVATAR["RAT_OGRE"] = "rat_ogre";
    AVATAR["RAT"] = "rat";
    AVATAR["ROTSPAWN"] = "rotspawn";
    AVATAR["TREEMAN"] = "treeman";
    AVATAR["TROLL"] = "troll";
    AVATAR["UNDEAD"] = "undead";
    AVATAR["WAGON"] = "wagon";
    AVATAR["WEREWOLF"] = "werewolf";
    AVATAR["YHETEE"] = "yhetee";
    AVATAR["MUMMIE"] = "mummie";
    AVATAR["SLANN"] = "slann";
})(AVATAR || (exports.AVATAR = AVATAR = {}));
// type : "E", "P", "M", "S", "A", "G"
// E: EXTRAORDINARY
// P: PASSING
// M: MUTATION
// S: STRENGTH
// A: AGILITY
// G: GENERAL
// const ranges = [6, 16, 31, 51, 76, 176];
// https://web.archive.org/web/20090403112513/http://enefel.org/carriere.php
var CAREER_ID;
(function (CAREER_ID) {
    CAREER_ID["SLANN_LINEMAN"] = "slann-lineman";
    CAREER_ID["SLANN_CATCHER"] = "slann-catcher";
    CAREER_ID["SLANN_BLITZER"] = "slann-blitzer";
    CAREER_ID["SLANN_KROXIGOR"] = "slann-kroxigor";
    CAREER_ID["SNOTLING_LINEMAN"] = "snotling-lineman";
    CAREER_ID["SNOTLING_RUNNER"] = "snotling-runner";
    CAREER_ID["SNOTLING_WAGON"] = "snotling-wagon";
    CAREER_ID["SNOTLING_TROLL"] = "snotling-troll";
    CAREER_ID["NURGLE_ROTTER"] = "nurgle-rotter";
    CAREER_ID["NURGLE_PESTIGOR"] = "nurgle-pestigor";
    CAREER_ID["NURGLE_BLOATER"] = "nurgle-bloater";
    CAREER_ID["NURGLE_ROTSPAWN"] = "nurgle-rotspawn";
    CAREER_ID["NECROMANTIC_ZOMBIE"] = "necromantic-zombie";
    CAREER_ID["NECROMANTIC_GHOUL"] = "necromantic-ghoul";
    CAREER_ID["NECROMANTIC_WRAITH"] = "necromantic-wraith";
    CAREER_ID["NECROMANTIC_WEREWOLF"] = "necromantic-werewolf";
    CAREER_ID["NECROMANTIC_GOLEM"] = "necromantic-golem";
    CAREER_ID["KHORNE_LINEMAN"] = "khorne-lineman";
    CAREER_ID["KHORNE_KHORNGOR"] = "khorne-khorngor";
    CAREER_ID["KHORNE_BLOODSEEKER"] = "khorne-bloodseeker";
    CAREER_ID["KHORNE_BLOODSPAWN"] = "khorne-bloodspawn";
    CAREER_ID["IMPERIAL_LINEMAN"] = "imperial-lineman";
    CAREER_ID["IMPERIAL_THROWER"] = "imperial-thrower";
    CAREER_ID["IMPERIAL_BLITZER"] = "imperial-blitzer";
    CAREER_ID["IMPERIAL_BODYGUARD"] = "imperial-bodyguard";
    CAREER_ID["IMPERIAL_OGRE"] = "imperial-ogre";
    CAREER_ID["GOBELIN_LINEMAN"] = "gobelin-lineman";
    CAREER_ID["GOBELIN_LOONEY"] = "gobelin-looney";
    CAREER_ID["GOBELIN_POGOER"] = "gobelin-pogoer";
    CAREER_ID["GOBELIN_TROLL"] = "gobelin-troll";
    CAREER_ID["VAMPIRE_THRALL"] = "vampire-thrall";
    CAREER_ID["VAMPIRE_VAMPIRE"] = "vampire-vampire";
    CAREER_ID["ELVEN_UNION_LINEMAN"] = "elven-union-lineman";
    CAREER_ID["ELVEN_UNION_THROWER"] = "elven-union-thrower";
    CAREER_ID["ELVEN_UNION_CATCHER"] = "elven-union-catcher";
    CAREER_ID["ELVEN_UNION_BLITZER"] = "elven-union-blitzer";
    CAREER_ID["UNDEAD_SKELETON"] = "undead-skeleton";
    CAREER_ID["UNDEAD_ZOMBIE"] = "undead-zombie";
    CAREER_ID["UNDEAD_GHOUL"] = "undead-ghoul";
    CAREER_ID["UNDEAD_WIGHT"] = "undead-wight";
    CAREER_ID["UNDEAD_MUMMIES"] = "undead-mummies";
    CAREER_ID["LIZARDMEN_SKINK"] = "lizardmen-skink";
    CAREER_ID["LIZARDMEN_CHAMELEON"] = "lizardmen-chameleon";
    CAREER_ID["LIZARDMEN_SAURUS"] = "lizardmen-saurus";
    CAREER_ID["LIZARDMEN_KROXIGOR"] = "lizardmen-kroxigor";
    CAREER_ID["NORSE_LINEMAN"] = "norse-lineman";
    CAREER_ID["NORSE_THROWER"] = "norse-thrower";
    CAREER_ID["NORSE_CATCHER"] = "norse-catcher";
    CAREER_ID["NORSE_BERSERKER"] = "norse-berserker";
    CAREER_ID["NORSE_ULFWERENERS"] = "norse-ulfwereners";
    CAREER_ID["NORSE_YHETEE"] = "norse-yhetee";
    CAREER_ID["AMAZON_LINEWOMEN"] = "amazon-linewomen";
    CAREER_ID["AMAZON_THROWER"] = "amazon-thrower";
    CAREER_ID["AMAZON_CATCHER"] = "amazon-catcher";
    CAREER_ID["AMAZON_BLITZER"] = "amazon-blitzer";
    CAREER_ID["HUMAN_LINEMAN"] = "human-lineman";
    CAREER_ID["HUMAN_CATCHER"] = "human-catcher";
    CAREER_ID["HUMAN_THROWER"] = "human-thrower";
    CAREER_ID["HUMAN_BLITZER"] = "human-blitzer";
    CAREER_ID["HUMAN_OGRE"] = "human-ogre";
    CAREER_ID["ORC_LINEMAN"] = "orc-lineman";
    CAREER_ID["ORC_THROWER"] = "orc-thrower";
    CAREER_ID["ORC_BLITZER"] = "orc-blitzer";
    CAREER_ID["ORC_BLACK_ORC"] = "orc-black-orc";
    CAREER_ID["ORC_TROLL"] = "orc-troll";
    CAREER_ID["DWARF_BLOCKER"] = "dwarf-blocker";
    CAREER_ID["DWARF_RUNNER"] = "dwarf-runner";
    CAREER_ID["DWARF_BLITZER"] = "dwarf-blitzer";
    CAREER_ID["DWARF_TROLL_SLAYER"] = "dwarf-troll-slayer";
    CAREER_ID["DWARF_DEATHROLLER"] = "deathroller";
    CAREER_ID["RAT_LINEMAN"] = "rat-lineman";
    CAREER_ID["RAT_THROWER"] = "rat-thrower";
    CAREER_ID["RAT_RUNNER"] = "rat-runner";
    CAREER_ID["RAT_BLITZER"] = "rat-blitzer";
    CAREER_ID["RAT_OGRE"] = "rat-ogre";
    CAREER_ID["SILVAN_LINEMAN"] = "silvan-lineman";
    CAREER_ID["SILVAN_CATCHER"] = "silvan-catcher";
    CAREER_ID["SILVAN_THROWER"] = "silvan-thrower";
    CAREER_ID["SILVAN_WARDANCER"] = "silvan-wardancer";
    CAREER_ID["CHAOS_BEASTMAN"] = "chaos-beastman";
    CAREER_ID["CHAOS_WARRIOR"] = "chaos-warrior";
    CAREER_ID["CHAOS_MINOTAUR"] = "chaos-minotaur";
    CAREER_ID["DARK_ELFE_LINEMAN"] = "dark-elfe-lineman";
    CAREER_ID["DARK_ELFE_RUNNER"] = "dark-elfe-runner";
    CAREER_ID["DARK_ELFE_BLITZER"] = "dark-elfe-blitzer";
    CAREER_ID["DARK_ELFE_WITCH"] = "dark-elfe-witch";
    CAREER_ID["CHAOS_DWARF_HOBGOBELIN"] = "chaos-dwarf-hobgobelin";
    CAREER_ID["CHAOS_DWARF_BLOCKER"] = "chaos-dwarf-blocker";
    CAREER_ID["CHAOS_DWARF_BULL_CENTAUR"] = "chaos-dwarf-bull-centaur";
    CAREER_ID["HALFLING_LINEMAN"] = "halfling-lineman";
    CAREER_ID["HALFLING_HEFTY"] = "halfling-hefty";
    CAREER_ID["HALFLING_CATCHER"] = "halfling-catcher";
    CAREER_ID["HALFLING_TREEMAN"] = "halfling-treeman";
})(CAREER_ID || (exports.CAREER_ID = CAREER_ID = {}));
var CAREER_VERSION;
(function (CAREER_VERSION) {
    CAREER_VERSION["V6"] = "v6";
    CAREER_VERSION["V2020"] = "v2020";
    CAREER_VERSION["V2025"] = "v2025";
})(CAREER_VERSION || (exports.CAREER_VERSION = CAREER_VERSION = {}));
const CAREER = {
    // SLANN
    [CAREER_ID.SLANN_LINEMAN]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 8,
        normal: "G",
        double: "AS",
        normalCoach: "G",
        icons: ["slann-lineman1"],
        skills: [skill_1.SKILL_NAMES.POGO_STICK, skill_1.SKILL_NAMES.VERY_LONG_LEGS],
        avatars: [AVATAR.SLANN],
        badge: RACE.SLANN,
        range: 0,
        cost: 60,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.SLANN_CATCHER]: {
        MA: 7,
        ST: 2,
        AG: 4,
        PA: 4,
        AV: 7,
        normal: "AG",
        double: "PS",
        normalCoach: "G",
        icons: ["slann-catcher1"],
        skills: [
            skill_1.SKILL_NAMES.POGO_STICK,
            skill_1.SKILL_NAMES.VERY_LONG_LEGS,
            skill_1.SKILL_NAMES.DIVING_CATCH,
            skill_1.SKILL_NAMES.SPECIALIST,
        ],
        avatars: [AVATAR.SLANN],
        badge: RACE.SLANN,
        range: 1,
        cost: 80,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.SLANN_BLITZER]: {
        MA: 7,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 8,
        normal: "AGS",
        double: "P",
        normalCoach: "G",
        icons: ["slann-blitzer1"],
        skills: [
            skill_1.SKILL_NAMES.POGO_STICK,
            skill_1.SKILL_NAMES.VERY_LONG_LEGS,
            skill_1.SKILL_NAMES.DIVING_TACKLE,
            skill_1.SKILL_NAMES.JUMP_UP,
            skill_1.SKILL_NAMES.STAR,
        ],
        avatars: [AVATAR.SLANN],
        badge: RACE.SLANN,
        range: 4,
        cost: 110,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.SLANN_KROXIGOR]: {
        MA: 6,
        ST: 5,
        AG: 1,
        PA: 1,
        AV: 9,
        normal: "S",
        double: "AG",
        normalCoach: "G",
        icons: ["slann-kroxigor1"],
        skills: [
            skill_1.SKILL_NAMES.BONE_HEAD,
            [skill_1.SKILL_NAMES.LONER, 4],
            [skill_1.SKILL_NAMES.MIGHTY_BLOW, 1],
            skill_1.SKILL_NAMES.PREHENSILE_TAIL,
            skill_1.SKILL_NAMES.THICK_SKULL,
            skill_1.SKILL_NAMES.BIG_GUY,
        ],
        avatars: [AVATAR.SLANN],
        badge: RACE.SLANN,
        range: 6,
        cost: 140,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    // SNOTLING
    [CAREER_ID.SNOTLING_LINEMAN]: {
        MA: 5,
        ST: 1,
        AG: 3,
        PA: 3,
        AV: 5,
        normal: "A",
        double: "G",
        normalCoach: "G",
        icons: ["snotling-lineman1"],
        skills: [
            skill_1.SKILL_NAMES.DODGE,
            skill_1.SKILL_NAMES.RIGHT_STUFF,
            skill_1.SKILL_NAMES.STUNTY,
            skill_1.SKILL_NAMES.TITCHY,
            skill_1.SKILL_NAMES.FEND, // replace Side Step
            // Swarming
        ],
        avatars: [AVATAR.GOBELIN],
        badge: RACE.SNOTLING,
        range: 0,
        cost: 15,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.SNOTLING_RUNNER]: {
        MA: 6,
        ST: 1,
        AG: 3,
        PA: 3,
        AV: 5,
        normal: "A",
        double: "G",
        normalCoach: "G",
        icons: ["snotling-runner1"],
        skills: [
            skill_1.SKILL_NAMES.DODGE,
            skill_1.SKILL_NAMES.RIGHT_STUFF,
            skill_1.SKILL_NAMES.STUNTY,
            skill_1.SKILL_NAMES.SPRINT,
            skill_1.SKILL_NAMES.SPECIALIST,
            skill_1.SKILL_NAMES.FEND, // replace Side Step
        ],
        avatars: [AVATAR.GOBELIN],
        badge: RACE.SNOTLING,
        range: 1,
        cost: 20,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.SNOTLING_WAGON]: {
        MA: 4,
        ST: 5,
        AG: 2,
        PA: 2,
        AV: 8,
        normal: "S",
        double: "AG",
        normalCoach: "G",
        icons: ["snotling-wagon1"],
        skills: [
            [skill_1.SKILL_NAMES.DIRTY_PLAYER, 1],
            skill_1.SKILL_NAMES.JUGGERNAUT,
            [skill_1.SKILL_NAMES.MIGHTY_BLOW, 1],
            skill_1.SKILL_NAMES.REALLY_STUPID,
            skill_1.SKILL_NAMES.STAND_FIRM,
            skill_1.SKILL_NAMES.STAR,
            skill_1.SKILL_NAMES.SECRET_WEAPON,
        ],
        avatars: [AVATAR.WAGON],
        badge: RACE.SNOTLING,
        range: 4,
        cost: 105,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.SNOTLING_TROLL]: {
        MA: 4,
        ST: 5,
        AG: 1,
        PA: 1,
        AV: 9,
        normal: "S",
        double: "AGP",
        normalCoach: "G",
        icons: ["snotling-troll1"],
        skills: [
            skill_1.SKILL_NAMES.ALWAYS_HUNGRY,
            [skill_1.SKILL_NAMES.LONER, 3],
            [skill_1.SKILL_NAMES.MIGHTY_BLOW, 1],
            skill_1.SKILL_NAMES.PROJECTILE_VOMIT,
            skill_1.SKILL_NAMES.REALLY_STUPID,
            skill_1.SKILL_NAMES.REGENERATION,
            skill_1.SKILL_NAMES.THROW_TEAM_MATE,
            skill_1.SKILL_NAMES.BIG_GUY,
        ],
        avatars: [AVATAR.TROLL],
        badge: RACE.SNOTLING,
        range: 5,
        cost: 115,
        version: CAREER_VERSION.V6,
    },
    // NURGLE
    [CAREER_ID.NURGLE_ROTTER]: {
        MA: 5,
        ST: 3,
        AG: 2,
        PA: 2,
        AV: 8,
        normal: "GM",
        double: "AS",
        normalCoach: "G",
        icons: ["nurgle-rotter1"],
        skills: [skill_1.SKILL_NAMES.DECAY, skill_1.SKILL_NAMES.PLAGUE_RIDDEN],
        avatars: [AVATAR.UNDEAD],
        badge: RACE.NURGLE,
        range: 0,
        cost: 35,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.NURGLE_PESTIGOR]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 8,
        normal: "GMS",
        double: "AP",
        normalCoach: "G",
        icons: ["nurgle-pestigor1"],
        skills: [
            skill_1.SKILL_NAMES.HORNS,
            skill_1.SKILL_NAMES.REGENERATION,
            skill_1.SKILL_NAMES.SPECIALIST,
            skill_1.SKILL_NAMES.PLAGUE_RIDDEN,
        ],
        avatars: [AVATAR.BEASTMAN],
        badge: RACE.NURGLE,
        range: 1,
        cost: 75,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.NURGLE_BLOATER]: {
        MA: 4,
        ST: 4,
        AG: 2,
        PA: 2,
        AV: 9,
        normal: "GMS",
        double: "A",
        normalCoach: "G",
        icons: ["nurgle-bloater1"],
        skills: [
            skill_1.SKILL_NAMES.DISTURBING_PRESENCE,
            skill_1.SKILL_NAMES.FOUL_APPEARANCE,
            skill_1.SKILL_NAMES.REGENERATION,
            skill_1.SKILL_NAMES.STAR,
            skill_1.SKILL_NAMES.PLAGUE_RIDDEN,
        ],
        avatars: [AVATAR.BLOATER],
        badge: RACE.NURGLE,
        range: 5,
        cost: 115,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.NURGLE_ROTSPAWN]: {
        MA: 4,
        ST: 5,
        AG: 1,
        PA: 1,
        AV: 9,
        normal: "S",
        double: "AGM",
        normalCoach: "G",
        icons: ["nurgle-rotspawn1"],
        skills: [
            skill_1.SKILL_NAMES.DISTURBING_PRESENCE,
            skill_1.SKILL_NAMES.FOUL_APPEARANCE,
            [skill_1.SKILL_NAMES.LONER, 4],
            [skill_1.SKILL_NAMES.MIGHTY_BLOW, 1],
            skill_1.SKILL_NAMES.REGENERATION,
            skill_1.SKILL_NAMES.PLAGUE_RIDDEN,
            skill_1.SKILL_NAMES.REALLY_STUPID,
            skill_1.SKILL_NAMES.TENTACLES,
            skill_1.SKILL_NAMES.BIG_GUY,
        ],
        avatars: [AVATAR.ROTSPAWN],
        badge: RACE.NURGLE,
        range: 6,
        cost: 140,
        version: CAREER_VERSION.V6,
    },
    // NECROMANTIC
    [CAREER_ID.NECROMANTIC_ZOMBIE]: {
        MA: 4,
        ST: 3,
        AG: 2,
        PA: 2,
        AV: 8,
        normal: "G",
        double: "AS",
        normalCoach: "G",
        icons: ["necromantic-zombie1"],
        skills: [skill_1.SKILL_NAMES.REGENERATION],
        avatars: [AVATAR.UNDEAD],
        badge: RACE.NECROMANTIC,
        range: 0,
        cost: 40,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.NECROMANTIC_GHOUL]: {
        MA: 7,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 7,
        normal: "AG",
        double: "PS",
        normalCoach: "G",
        icons: ["necromantic-ghoul1"],
        skills: [skill_1.SKILL_NAMES.DODGE, skill_1.SKILL_NAMES.SPECIALIST],
        avatars: [AVATAR.UNDEAD],
        badge: RACE.NECROMANTIC,
        range: 1,
        cost: 75,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.NECROMANTIC_WRAITH]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 8,
        normal: "GS",
        double: "A",
        normalCoach: "G",
        icons: ["necromantic-wraith1"],
        skills: [
            skill_1.SKILL_NAMES.BLOCK,
            skill_1.SKILL_NAMES.FOUL_APPEARANCE,
            skill_1.SKILL_NAMES.REGENERATION,
            skill_1.SKILL_NAMES.SPECIALIST,
            skill_1.SKILL_NAMES.NO_HANDS,
            skill_1.SKILL_NAMES.FEND, // replace SIDE_STEP,
        ],
        avatars: [AVATAR.UNDEAD],
        badge: RACE.NECROMANTIC,
        range: 2,
        cost: 95,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.NECROMANTIC_WEREWOLF]: {
        MA: 8,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 8,
        normal: "AG",
        double: "PS",
        normalCoach: "G",
        icons: ["necromantic-werewolf1"],
        skills: [
            skill_1.SKILL_NAMES.CLAW,
            skill_1.SKILL_NAMES.FRENZY,
            skill_1.SKILL_NAMES.STAR,
            skill_1.SKILL_NAMES.REGENERATION,
        ],
        avatars: [AVATAR.WEREWOLF],
        badge: RACE.NECROMANTIC,
        range: 5,
        cost: 125,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.NECROMANTIC_GOLEM]: {
        MA: 4,
        ST: 4,
        AG: 2,
        PA: 2,
        AV: 9,
        normal: "GS",
        double: "A",
        normalCoach: "G",
        icons: ["necromantic-golem1"],
        skills: [
            skill_1.SKILL_NAMES.REGENERATION,
            skill_1.SKILL_NAMES.STAND_FIRM,
            skill_1.SKILL_NAMES.THICK_SKULL,
            skill_1.SKILL_NAMES.BIG_GUY,
        ],
        avatars: [AVATAR.GOLEM],
        badge: RACE.NECROMANTIC,
        range: 6,
        cost: 115,
        version: CAREER_VERSION.V6,
    },
    // KHORNE
    [CAREER_ID.KHORNE_LINEMAN]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 7,
        normal: "GM",
        double: "AS",
        normalCoach: "G",
        icons: ["khorne-lineman1"],
        skills: [skill_1.SKILL_NAMES.FRENZY],
        avatars: [AVATAR.HUMAN],
        badge: RACE.KHORNE,
        range: 0,
        cost: 50,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.KHORNE_KHORNGOR]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 8,
        normal: "GMS",
        double: "AP",
        normalCoach: "G",
        icons: ["khorne-khorngor1"],
        skills: [skill_1.SKILL_NAMES.HORNS, skill_1.SKILL_NAMES.JUGGERNAUT, skill_1.SKILL_NAMES.SPECIALIST],
        avatars: [AVATAR.BEASTMAN],
        badge: RACE.KHORNE,
        range: 1,
        cost: 70,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.KHORNE_BLOODSEEKER]: {
        MA: 5,
        ST: 4,
        AG: 2,
        PA: 2,
        AV: 9,
        normal: "GMS",
        double: "A",
        normalCoach: "G",
        icons: ["khorne-bloodseeker1"],
        skills: [skill_1.SKILL_NAMES.FRENZY, skill_1.SKILL_NAMES.STAR],
        avatars: [AVATAR.CHAOS_WARRIOR],
        badge: RACE.KHORNE,
        range: 5,
        cost: 110,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.KHORNE_BLOODSPAWN]: {
        MA: 5,
        ST: 5,
        AG: 2,
        PA: 2,
        AV: 8,
        normal: "MS",
        double: "AG",
        normalCoach: "G",
        icons: ["khorne-bloodspawn1"],
        skills: [
            skill_1.SKILL_NAMES.CLAW,
            skill_1.SKILL_NAMES.FRENZY,
            skill_1.SKILL_NAMES.BIG_GUY,
            [skill_1.SKILL_NAMES.LONER, 4],
            [skill_1.SKILL_NAMES.MIGHTY_BLOW, 1],
            skill_1.SKILL_NAMES.UNCHANNELLED_FURY,
        ],
        avatars: [AVATAR.BLOODSPAWN],
        badge: RACE.KHORNE,
        range: 6,
        cost: 160,
        version: CAREER_VERSION.V6,
    },
    // IMPERIAL
    [CAREER_ID.IMPERIAL_LINEMAN]: {
        MA: 6,
        ST: 3,
        AG: 2,
        PA: 2,
        AV: 7,
        normal: "G",
        double: "AS",
        normalCoach: "G",
        icons: ["imperial-lineman1"],
        skills: [skill_1.SKILL_NAMES.FEND],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.IMPERIAL,
        range: 0,
        cost: 45,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.IMPERIAL_THROWER]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 8,
        normal: "GP",
        double: "AS",
        normalCoach: "G",
        icons: ["imperial-thrower1"],
        skills: [skill_1.SKILL_NAMES.PASS, skill_1.SKILL_NAMES.GIVE_AND_GO, skill_1.SKILL_NAMES.SPECIALIST],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.IMPERIAL,
        range: 1,
        cost: 75,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.IMPERIAL_BLITZER]: {
        MA: 7,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 8,
        normal: "AG",
        double: "PS",
        normalCoach: "G",
        icons: ["imperial-blitzer1"],
        skills: [skill_1.SKILL_NAMES.BLOCK, skill_1.SKILL_NAMES.CATCH, skill_1.SKILL_NAMES.SPECIALIST],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.IMPERIAL,
        range: 3,
        cost: 105,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.IMPERIAL_BODYGUARD]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 8,
        normal: "GS",
        double: "A",
        normalCoach: "G",
        icons: ["imperial-bodyguard1"],
        skills: [
            skill_1.SKILL_NAMES.STAND_FIRM,
            skill_1.SKILL_NAMES.WRESTLE,
            skill_1.SKILL_NAMES.SPECIALIST,
        ],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.IMPERIAL,
        range: 2,
        cost: 90,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.IMPERIAL_OGRE]: {
        MA: 5,
        ST: 5,
        AG: 2,
        PA: 2,
        AV: 9,
        normal: "S",
        double: "AG",
        normalCoach: "G",
        icons: ["imperial-ogre1"],
        skills: [
            [skill_1.SKILL_NAMES.LONER, 4],
            skill_1.SKILL_NAMES.BONE_HEAD,
            [skill_1.SKILL_NAMES.MIGHTY_BLOW, 1],
            skill_1.SKILL_NAMES.THICK_SKULL,
            skill_1.SKILL_NAMES.THROW_TEAM_MATE,
            skill_1.SKILL_NAMES.BIG_GUY,
        ],
        avatars: [AVATAR.OGRE],
        badge: RACE.IMPERIAL,
        range: 6,
        cost: 140,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    // GOBELIN
    [CAREER_ID.GOBELIN_LINEMAN]: {
        MA: 6,
        ST: 2,
        AG: 3,
        PA: 3,
        AV: 7,
        normal: "A",
        double: "GPS",
        normalCoach: "G",
        icons: ["gobelin-lineman1"],
        skills: [skill_1.SKILL_NAMES.DODGE, skill_1.SKILL_NAMES.RIGHT_STUFF, skill_1.SKILL_NAMES.STUNTY],
        avatars: [AVATAR.GOBELIN],
        badge: RACE.GOBELIN,
        range: 0,
        cost: 40,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.GOBELIN_LOONEY]: {
        MA: 6,
        ST: 2,
        AG: 3,
        PA: 3,
        AV: 7,
        normal: "A",
        double: "GS",
        normalCoach: "G",
        icons: ["gobelin-looney1"],
        skills: [
            [skill_1.SKILL_NAMES.CHAINSAW, 3],
            skill_1.SKILL_NAMES.SECRET_WEAPON,
            skill_1.SKILL_NAMES.STUNTY,
        ],
        avatars: [AVATAR.GOBELIN],
        badge: RACE.GOBELIN,
        range: 2,
        cost: 40,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.GOBELIN_POGOER]: {
        MA: 7,
        ST: 2,
        AG: 3,
        PA: 3,
        AV: 7,
        normal: "A",
        double: "GPS",
        normalCoach: "G",
        icons: ["gobelin-pogoer1"],
        skills: [skill_1.SKILL_NAMES.DODGE, skill_1.SKILL_NAMES.POGO_STICK, skill_1.SKILL_NAMES.STUNTY],
        avatars: [AVATAR.GOBELIN],
        badge: RACE.GOBELIN,
        range: 3,
        cost: 75,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.GOBELIN_TROLL]: {
        MA: 4,
        ST: 5,
        AG: 1,
        PA: 1,
        AV: 9,
        normal: "S",
        double: "AGP",
        normalCoach: "G",
        icons: ["gobelin-troll1"],
        skills: [
            skill_1.SKILL_NAMES.BIG_GUY,
            skill_1.SKILL_NAMES.ALWAYS_HUNGRY,
            [skill_1.SKILL_NAMES.LONER, 3],
            [skill_1.SKILL_NAMES.MIGHTY_BLOW, 1],
            skill_1.SKILL_NAMES.PROJECTILE_VOMIT,
            skill_1.SKILL_NAMES.REALLY_STUPID,
            skill_1.SKILL_NAMES.REGENERATION,
            skill_1.SKILL_NAMES.THROW_TEAM_MATE,
        ],
        avatars: [AVATAR.TROLL],
        badge: RACE.GOBELIN,
        range: 5,
        cost: 115,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    // VAMPIRE
    [CAREER_ID.VAMPIRE_THRALL]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 7,
        normal: "G",
        double: "AS",
        normalCoach: "G",
        icons: ["vampire-thrall1"],
        skills: [],
        avatars: [AVATAR.HUMAN, AVATAR.UNDEAD],
        badge: RACE.VAMPIRE,
        range: 0,
        cost: 40,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.VAMPIRE_VAMPIRE]: {
        MA: 6,
        ST: 4,
        AG: 4,
        PA: 4,
        AV: 8,
        normal: "AGS",
        double: "P",
        normalCoach: "G",
        icons: ["vampire-vampire1"],
        skills: [
            skill_1.SKILL_NAMES.ANIMAL_SAVAGERY,
            skill_1.SKILL_NAMES.REGENERATION,
            skill_1.SKILL_NAMES.STAR,
            skill_1.SKILL_NAMES.HYPNOTIC_GAZE,
        ],
        avatars: [AVATAR.HUMAN, AVATAR.UNDEAD],
        badge: RACE.VAMPIRE,
        range: 5,
        cost: 110,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    // ELVEN_UNION
    [CAREER_ID.ELVEN_UNION_LINEMAN]: {
        MA: 6,
        ST: 3,
        AG: 4,
        PA: 4,
        AV: 7,
        normal: "AG",
        double: "S",
        normalCoach: "G",
        icons: ["elven-union-lineman1"],
        skills: [],
        avatars: [AVATAR.DARK_ELF, AVATAR.ELF, AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.ELVEN_UNION,
        range: 0,
        cost: 60,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.ELVEN_UNION_THROWER]: {
        MA: 6,
        ST: 3,
        AG: 4,
        PA: 4,
        AV: 7,
        normal: "AGP",
        double: "S",
        normalCoach: "G",
        icons: ["elven-union-thrower1"],
        skills: [skill_1.SKILL_NAMES.PASS, skill_1.SKILL_NAMES.SPECIALIST],
        avatars: [AVATAR.DARK_ELF, AVATAR.ELF, AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.ELVEN_UNION,
        range: 1,
        cost: 75,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.ELVEN_UNION_CATCHER]: {
        MA: 8,
        ST: 3,
        AG: 4,
        PA: 4,
        AV: 7,
        normal: "AG",
        double: "S",
        normalCoach: "G",
        icons: ["elven-union-catcher1"],
        skills: [
            skill_1.SKILL_NAMES.CATCH,
            skill_1.SKILL_NAMES.NERVES_OF_STEEL,
            skill_1.SKILL_NAMES.SPECIALIST,
        ],
        avatars: [AVATAR.DARK_ELF, AVATAR.ELF, AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.ELVEN_UNION,
        range: 2,
        cost: 100,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.ELVEN_UNION_BLITZER]: {
        MA: 7,
        ST: 3,
        AG: 4,
        PA: 4,
        AV: 8,
        normal: "AG",
        double: "PS",
        normalCoach: "G",
        icons: ["elven-union-blitzer1"],
        skills: [
            skill_1.SKILL_NAMES.BLOCK,
            skill_1.SKILL_NAMES.SPECIALIST,
            skill_1.SKILL_NAMES.FEND, // Replace Side Step
        ],
        avatars: [AVATAR.DARK_ELF, AVATAR.ELF, AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.ELVEN_UNION,
        range: 3,
        cost: 115,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    // Undead
    [CAREER_ID.UNDEAD_SKELETON]: {
        MA: 5,
        ST: 3,
        AG: 2,
        PA: 2,
        AV: 7,
        normal: "G",
        double: "AS",
        normalCoach: "G",
        icons: ["undead-skeleton1"],
        skills: [skill_1.SKILL_NAMES.REGENERATION, skill_1.SKILL_NAMES.THICK_SKULL],
        avatars: [AVATAR.UNDEAD],
        badge: RACE.UNDEAD,
        range: 0,
        cost: 40,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.UNDEAD_ZOMBIE]: {
        MA: 4,
        ST: 3,
        AG: 2,
        PA: 2,
        AV: 8,
        normal: "G",
        double: "AS",
        normalCoach: "G",
        icons: ["undead-zombie1"],
        skills: [skill_1.SKILL_NAMES.REGENERATION],
        avatars: [AVATAR.UNDEAD],
        badge: RACE.UNDEAD,
        range: 1,
        cost: 40,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.UNDEAD_GHOUL]: {
        MA: 7,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 7,
        normal: "AG",
        double: "PS",
        normalCoach: "G",
        icons: ["undead-ghoul1"],
        skills: [skill_1.SKILL_NAMES.DODGE, skill_1.SKILL_NAMES.SPECIALIST],
        avatars: [AVATAR.UNDEAD],
        badge: RACE.UNDEAD,
        range: 2,
        cost: 75,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.UNDEAD_WIGHT]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 8,
        normal: "GS",
        double: "AP",
        normalCoach: "G",
        icons: ["undead-wight1"],
        skills: [
            skill_1.SKILL_NAMES.BLOCK,
            skill_1.SKILL_NAMES.REGENERATION,
            skill_1.SKILL_NAMES.SPECIALIST,
        ],
        avatars: [AVATAR.UNDEAD],
        badge: RACE.UNDEAD,
        range: 3,
        cost: 90,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.UNDEAD_MUMMIES]: {
        MA: 3,
        ST: 5,
        AG: 1,
        PA: 1,
        AV: 9,
        normal: "S",
        double: "AG",
        normalCoach: "G",
        icons: ["undead-mummies1"],
        skills: [
            [skill_1.SKILL_NAMES.MIGHTY_BLOW, 1],
            skill_1.SKILL_NAMES.REGENERATION,
            skill_1.SKILL_NAMES.STAR,
        ],
        avatars: [AVATAR.MUMMIE],
        badge: RACE.UNDEAD,
        range: 5,
        cost: 125,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    // LIZARDMEN
    [CAREER_ID.LIZARDMEN_SKINK]: {
        MA: 8,
        ST: 2,
        AG: 3,
        PA: 3,
        AV: 7,
        normal: "A",
        double: "GPS",
        normalCoach: "G",
        icons: ["lizardmen-skink1"],
        skills: [skill_1.SKILL_NAMES.DODGE, skill_1.SKILL_NAMES.STUNTY],
        avatars: [AVATAR.LIZARDMEN],
        badge: RACE.LIZARDMEN,
        range: 0,
        cost: 60,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.LIZARDMEN_CHAMELEON]: {
        MA: 7,
        ST: 2,
        AG: 3,
        PA: 3,
        AV: 7,
        normal: "A",
        double: "GPS",
        normalCoach: "G",
        icons: ["lizardmen-chameleon1"],
        skills: [
            skill_1.SKILL_NAMES.DODGE,
            skill_1.SKILL_NAMES.ON_THE_BALL,
            skill_1.SKILL_NAMES.SHADOWING,
            skill_1.SKILL_NAMES.STUNTY,
        ],
        avatars: [AVATAR.LIZARDMEN],
        badge: RACE.LIZARDMEN,
        range: 1,
        cost: 70,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.LIZARDMEN_SAURUS]: {
        MA: 6,
        ST: 4,
        AG: 1,
        PA: 1,
        AV: 9,
        normal: "GS",
        double: "A",
        normalCoach: "G",
        icons: ["lizardmen-saurus1"],
        skills: [skill_1.SKILL_NAMES.STAR],
        avatars: [AVATAR.LIZARDMEN],
        badge: RACE.LIZARDMEN,
        range: 5,
        cost: 85,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.LIZARDMEN_KROXIGOR]: {
        MA: 6,
        ST: 5,
        AG: 1,
        PA: 1,
        AV: 9,
        normal: "S",
        double: "AG",
        normalCoach: "G",
        icons: ["lizardmen-kroxigor1"],
        skills: [
            skill_1.SKILL_NAMES.BONE_HEAD,
            [skill_1.SKILL_NAMES.LONER, 4],
            [skill_1.SKILL_NAMES.MIGHTY_BLOW, 1],
            skill_1.SKILL_NAMES.PREHENSILE_TAIL,
            skill_1.SKILL_NAMES.THICK_SKULL,
            skill_1.SKILL_NAMES.BIG_GUY,
        ],
        avatars: [AVATAR.LIZARDMEN],
        badge: RACE.LIZARDMEN,
        range: 6,
        cost: 140,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    // NORSE
    [CAREER_ID.NORSE_LINEMAN]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 7,
        normal: "G",
        double: "AS",
        normalCoach: "G",
        icons: ["norse-lineman1"],
        skills: [skill_1.SKILL_NAMES.BLOCK],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.NORSE,
        range: 0,
        cost: 50,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.NORSE_THROWER]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 7,
        normal: "GP",
        double: "AS",
        normalCoach: "G",
        icons: ["norse-thrower1"],
        skills: [skill_1.SKILL_NAMES.BLOCK, skill_1.SKILL_NAMES.PASS, skill_1.SKILL_NAMES.SPECIALIST],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.NORSE,
        range: 1,
        cost: 70,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.NORSE_CATCHER]: {
        MA: 7,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 7,
        normal: "AG",
        double: "S",
        normalCoach: "G",
        icons: ["norse-catcher1"],
        skills: [skill_1.SKILL_NAMES.BLOCK, skill_1.SKILL_NAMES.DAUNTLESS, skill_1.SKILL_NAMES.SPECIALIST],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.NORSE,
        range: 2,
        cost: 90,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.NORSE_BERSERKER]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 7,
        normal: "GS",
        double: "A",
        normalCoach: "G",
        icons: ["norse-berserker1"],
        skills: [
            skill_1.SKILL_NAMES.BLOCK,
            skill_1.SKILL_NAMES.JUMP_UP,
            skill_1.SKILL_NAMES.FRENZY,
            skill_1.SKILL_NAMES.SPECIALIST,
        ],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.NORSE,
        range: 3,
        cost: 90,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.NORSE_ULFWERENERS]: {
        MA: 6,
        ST: 4,
        AG: 2,
        PA: 2,
        AV: 8,
        normal: "GS",
        double: "A",
        normalCoach: "G",
        icons: ["norse-ulfwereners1"],
        skills: [skill_1.SKILL_NAMES.FRENZY, skill_1.SKILL_NAMES.STAR],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.NORSE,
        range: 5,
        cost: 105,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.NORSE_YHETEE]: {
        MA: 5,
        ST: 5,
        AG: 1,
        PA: 1,
        AV: 8,
        normal: "S",
        double: "AG",
        normalCoach: "G",
        icons: ["norse-yhetee1"],
        skills: [
            skill_1.SKILL_NAMES.CLAW,
            skill_1.SKILL_NAMES.DISTURBING_PRESENCE,
            skill_1.SKILL_NAMES.FRENZY,
            [skill_1.SKILL_NAMES.LONER, 4],
            skill_1.SKILL_NAMES.UNCHANNELLED_FURY,
            skill_1.SKILL_NAMES.BIG_GUY,
        ],
        avatars: [AVATAR.YHETEE],
        badge: RACE.NORSE,
        range: 6,
        cost: 140,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    // AMAZON
    [CAREER_ID.AMAZON_LINEWOMEN]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 7,
        normal: "G",
        double: "AS",
        normalCoach: "G",
        icons: ["amazon-linewomen1"],
        skills: [skill_1.SKILL_NAMES.DODGE],
        avatars: [AVATAR.HUMAN_WOMAN],
        badge: RACE.AMAZON,
        range: 0,
        cost: 50,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.AMAZON_THROWER]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 7,
        normal: "GP",
        double: "AS",
        normalCoach: "G",
        icons: ["amazon-thrower1"],
        skills: [skill_1.SKILL_NAMES.PASS, skill_1.SKILL_NAMES.DODGE, skill_1.SKILL_NAMES.SPECIALIST],
        avatars: [AVATAR.HUMAN_WOMAN],
        badge: RACE.AMAZON,
        range: 1,
        cost: 75,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.AMAZON_CATCHER]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 7,
        normal: "AG",
        double: "S",
        normalCoach: "G",
        icons: ["amazon-catcher1"],
        skills: [skill_1.SKILL_NAMES.CATCH, skill_1.SKILL_NAMES.DODGE, skill_1.SKILL_NAMES.SPECIALIST],
        avatars: [AVATAR.HUMAN_WOMAN],
        badge: RACE.AMAZON,
        range: 2,
        cost: 75,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.AMAZON_BLITZER]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 7,
        normal: "GS",
        double: "A",
        normalCoach: "G",
        icons: ["amazon-blitzer1"],
        skills: [skill_1.SKILL_NAMES.BLOCK, skill_1.SKILL_NAMES.DODGE, skill_1.SKILL_NAMES.SPECIALIST],
        avatars: [AVATAR.HUMAN_WOMAN],
        badge: RACE.AMAZON,
        range: 3,
        cost: 90,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    // HUMAN
    [CAREER_ID.HUMAN_LINEMAN]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 8,
        normal: "G",
        double: "ASP",
        normalCoach: "G",
        icons: ["human1"],
        skills: [],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.HUMAN,
        range: 0,
        cost: 50,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.HUMAN_CATCHER]: {
        MA: 8,
        ST: 2,
        AG: 3,
        PA: 3,
        AV: 7,
        normal: "GA",
        double: "SP",
        normalCoach: "G",
        icons: ["human-catcher1"],
        skills: [skill_1.SKILL_NAMES.CATCH, skill_1.SKILL_NAMES.DODGE, skill_1.SKILL_NAMES.SPECIALIST],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.HUMAN,
        range: 1,
        cost: 70,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.HUMAN_THROWER]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 8,
        normal: "GP",
        double: "AS",
        normalCoach: "G",
        icons: ["human-thrower1"],
        skills: [skill_1.SKILL_NAMES.SURE_HANDS, skill_1.SKILL_NAMES.PASS, skill_1.SKILL_NAMES.SPECIALIST],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.HUMAN,
        range: 2,
        cost: 70,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.HUMAN_BLITZER]: {
        MA: 7,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 8,
        normal: "GS",
        double: "AP",
        normalCoach: "G",
        icons: ["human-blitzer1"],
        skills: [skill_1.SKILL_NAMES.BLOCK, skill_1.SKILL_NAMES.STAR],
        avatars: [AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.HUMAN,
        range: 4,
        cost: 90,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.HUMAN_OGRE]: {
        MA: 5,
        ST: 5,
        AG: 2,
        PA: 2,
        AV: 9,
        normal: "S",
        double: "GA",
        normalCoach: "G",
        icons: ["human-ogre1"],
        skills: [
            skill_1.SKILL_NAMES.BONE_HEAD,
            [skill_1.SKILL_NAMES.LONER, 4],
            [skill_1.SKILL_NAMES.MIGHTY_BLOW, 1],
            skill_1.SKILL_NAMES.THICK_SKULL,
            skill_1.SKILL_NAMES.THROW_TEAM_MATE,
            skill_1.SKILL_NAMES.BIG_GUY,
        ],
        avatars: [AVATAR.OGRE],
        badge: RACE.HUMAN,
        range: 6,
        cost: 140,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    // ORC
    [CAREER_ID.ORC_LINEMAN]: {
        MA: 5,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 9,
        normal: "G",
        double: "ASP",
        normalCoach: "G",
        icons: ["orc1"],
        skills: [],
        avatars: [AVATAR.ORC],
        badge: RACE.ORC,
        range: 0,
        cost: 50,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.ORC_THROWER]: {
        MA: 5,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 8,
        normal: "GP",
        double: "AS",
        normalCoach: "G",
        icons: ["orc-thrower1"],
        skills: [skill_1.SKILL_NAMES.SURE_HANDS, skill_1.SKILL_NAMES.PASS, skill_1.SKILL_NAMES.SPECIALIST],
        avatars: [AVATAR.ORC],
        badge: RACE.ORC,
        range: 1,
        cost: 70,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.ORC_BLITZER]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 9,
        normal: "GS",
        double: "AP",
        normalCoach: "G",
        icons: ["orc-blitzer1"],
        skills: [skill_1.SKILL_NAMES.BLOCK, skill_1.SKILL_NAMES.SPECIALIST],
        avatars: [AVATAR.ORC],
        badge: RACE.ORC,
        range: 2,
        cost: 80,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.ORC_BLACK_ORC]: {
        MA: 4,
        ST: 4,
        AG: 2,
        PA: 2,
        AV: 9,
        normal: "GS",
        double: "AP",
        normalCoach: "G",
        icons: ["orc-black-orc1"],
        skills: [skill_1.SKILL_NAMES.STAR],
        avatars: [AVATAR.BLACK_ORC],
        badge: RACE.ORC,
        range: 5,
        cost: 80,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.ORC_TROLL]: {
        MA: 4,
        ST: 5,
        AG: 1,
        PA: 1,
        AV: 9,
        normal: "S",
        double: "GAP",
        normalCoach: "G",
        icons: ["orc-troll1"],
        skills: [
            skill_1.SKILL_NAMES.ALWAYS_HUNGRY,
            skill_1.SKILL_NAMES.BIG_GUY,
            [skill_1.SKILL_NAMES.LONER, 4],
            [skill_1.SKILL_NAMES.MIGHTY_BLOW, 1],
            skill_1.SKILL_NAMES.PROJECTILE_VOMIT,
            skill_1.SKILL_NAMES.REALLY_STUPID,
            skill_1.SKILL_NAMES.REGENERATION,
            skill_1.SKILL_NAMES.THROW_TEAM_MATE,
        ],
        avatars: [AVATAR.TROLL],
        badge: RACE.ORC,
        range: 6,
        cost: 115,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    // DWARF
    [CAREER_ID.DWARF_BLOCKER]: {
        MA: 4,
        ST: 3,
        AG: 2,
        PA: 2,
        AV: 9,
        normal: "GS",
        double: "AP",
        normalCoach: "G",
        icons: ["dwarf1"],
        skills: [skill_1.SKILL_NAMES.BLOCK, skill_1.SKILL_NAMES.TACKLE, skill_1.SKILL_NAMES.THICK_SKULL],
        avatars: [AVATAR.DWARF],
        badge: RACE.DWARF,
        range: 0,
        cost: 70,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.DWARF_RUNNER]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 8,
        normal: "GP",
        double: "AS",
        normalCoach: "G",
        icons: ["dwarf-runner1"],
        skills: [
            skill_1.SKILL_NAMES.SURE_HANDS,
            skill_1.SKILL_NAMES.THICK_SKULL,
            skill_1.SKILL_NAMES.SPECIALIST,
        ],
        avatars: [AVATAR.DWARF],
        badge: RACE.DWARF,
        range: 1,
        cost: 80,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.DWARF_BLITZER]: {
        MA: 5,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 9,
        normal: "GS",
        double: "AP",
        normalCoach: "G",
        icons: ["dwarf-blitzer1"],
        skills: [
            skill_1.SKILL_NAMES.BLOCK,
            skill_1.SKILL_NAMES.THICK_SKULL,
            skill_1.SKILL_NAMES.SPECIALIST,
        ],
        avatars: [AVATAR.DWARF],
        badge: RACE.DWARF,
        range: 2,
        cost: 80,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.DWARF_TROLL_SLAYER]: {
        MA: 5,
        ST: 3,
        AG: 2,
        PA: 2,
        AV: 8,
        normal: "GS",
        double: "AP",
        normalCoach: "G",
        icons: ["dwarf-troll-slayer1"],
        skills: [
            skill_1.SKILL_NAMES.STAR,
            skill_1.SKILL_NAMES.BLOCK,
            skill_1.SKILL_NAMES.DAUNTLESS,
            skill_1.SKILL_NAMES.FRENZY,
            skill_1.SKILL_NAMES.THICK_SKULL,
        ],
        avatars: [AVATAR.DWARF],
        badge: RACE.DWARF,
        range: 4,
        cost: 90,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.DWARF_DEATHROLLER]: {
        MA: 4,
        ST: 7,
        AG: 1,
        PA: 1,
        AV: 10,
        normal: "S",
        double: "AG",
        normalCoach: "G",
        icons: ["dwarf-deathroller1"],
        skills: [
            skill_1.SKILL_NAMES.BREAK_TACKLE,
            [skill_1.SKILL_NAMES.DIRTY_PLAYER, 2],
            skill_1.SKILL_NAMES.JUGGERNAUT,
            [skill_1.SKILL_NAMES.LONER, 5],
            [skill_1.SKILL_NAMES.MIGHTY_BLOW, 1],
            skill_1.SKILL_NAMES.NO_HANDS,
            skill_1.SKILL_NAMES.SECRET_WEAPON,
            skill_1.SKILL_NAMES.STAND_FIRM,
            skill_1.SKILL_NAMES.BIG_GUY,
        ],
        avatars: [AVATAR.DWARF],
        badge: RACE.DWARF,
        range: 6,
        cost: 170,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    // RAT
    [CAREER_ID.RAT_LINEMAN]: {
        MA: 7,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 7,
        normal: "G",
        double: "ASPM",
        normalCoach: "G",
        icons: ["rat1"],
        skills: [],
        avatars: [AVATAR.RAT],
        badge: RACE.RAT,
        range: 0,
        cost: 50,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.RAT_THROWER]: {
        MA: 7,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 7,
        normal: "GP",
        double: "ASM",
        normalCoach: "G",
        icons: ["rat-thrower1"],
        skills: [skill_1.SKILL_NAMES.PASS, skill_1.SKILL_NAMES.SURE_HANDS, skill_1.SKILL_NAMES.SPECIALIST],
        avatars: [AVATAR.RAT],
        badge: RACE.RAT,
        range: 1,
        cost: 70,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.RAT_RUNNER]: {
        MA: 9,
        ST: 2,
        AG: 4,
        PA: 4,
        AV: 7,
        normal: "GA",
        double: "SPM",
        normalCoach: "G",
        icons: ["rat-runner1"],
        skills: [skill_1.SKILL_NAMES.DODGE, skill_1.SKILL_NAMES.SPECIALIST],
        avatars: [AVATAR.RAT],
        badge: RACE.RAT,
        range: 2,
        cost: 80,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.RAT_BLITZER]: {
        MA: 7,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 8,
        normal: "GS",
        double: "APM",
        normalCoach: "G",
        icons: ["rat-blitzer1"],
        skills: [skill_1.SKILL_NAMES.STAR, skill_1.SKILL_NAMES.BLOCK],
        avatars: [AVATAR.RAT],
        badge: RACE.RAT,
        range: 4,
        cost: 90,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.RAT_OGRE]: {
        MA: 6,
        ST: 5,
        AG: 2,
        PA: 2,
        AV: 8,
        normal: "S",
        double: "AGM",
        normalCoach: "G",
        icons: ["rat-ogre1"],
        skills: [
            skill_1.SKILL_NAMES.BIG_GUY,
            skill_1.SKILL_NAMES.ANIMAL_SAVAGERY,
            skill_1.SKILL_NAMES.FRENZY,
            [skill_1.SKILL_NAMES.LONER, 4],
            [skill_1.SKILL_NAMES.MIGHTY_BLOW, 1],
            skill_1.SKILL_NAMES.PREHENSILE_TAIL,
        ],
        avatars: [AVATAR.RAT_OGRE],
        badge: RACE.RAT,
        range: 6,
        cost: 150,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    // SILVAN
    [CAREER_ID.SILVAN_LINEMAN]: {
        MA: 7,
        ST: 3,
        AG: 4,
        PA: 4,
        AV: 7,
        normal: "GA",
        double: "SP",
        normalCoach: "G",
        icons: ["silvan1"],
        skills: [],
        avatars: [AVATAR.DARK_ELF, AVATAR.ELF, AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.SILVAN,
        range: 0,
        cost: 70,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.SILVAN_CATCHER]: {
        MA: 8,
        ST: 2,
        AG: 4,
        PA: 4,
        AV: 7,
        normal: "GA",
        double: "SP",
        normalCoach: "G",
        icons: ["silvan-catcher1"],
        skills: [
            skill_1.SKILL_NAMES.CATCH,
            skill_1.SKILL_NAMES.DODGE,
            skill_1.SKILL_NAMES.SPRINT,
            skill_1.SKILL_NAMES.SPECIALIST,
        ],
        avatars: [AVATAR.DARK_ELF, AVATAR.ELF, AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.SILVAN,
        range: 1,
        cost: 90,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.SILVAN_THROWER]: {
        MA: 7,
        ST: 3,
        AG: 4,
        PA: 4,
        AV: 7,
        normal: "PGA",
        double: "S",
        normalCoach: "G",
        icons: ["silvan-thrower1"],
        skills: [skill_1.SKILL_NAMES.PASS, skill_1.SKILL_NAMES.SPECIALIST],
        avatars: [AVATAR.DARK_ELF, AVATAR.ELF, AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.SILVAN,
        range: 2,
        cost: 90,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.SILVAN_WARDANCER]: {
        MA: 8,
        ST: 3,
        AG: 4,
        PA: 4,
        AV: 7,
        normal: "GA",
        double: "SP",
        normalCoach: "G",
        icons: ["silvan-wardancer1"],
        skills: [
            skill_1.SKILL_NAMES.STAR,
            skill_1.SKILL_NAMES.BLOCK,
            skill_1.SKILL_NAMES.DODGE,
            skill_1.SKILL_NAMES.LEAP,
        ],
        avatars: [AVATAR.DARK_ELF, AVATAR.ELF, AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.SILVAN,
        range: 5,
        cost: 120,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    // CHAOS
    [CAREER_ID.CHAOS_BEASTMAN]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 8,
        normal: "GSM",
        double: "AP",
        normalCoach: "G",
        icons: ["chaos-beastman1"],
        skills: [skill_1.SKILL_NAMES.HORNS],
        avatars: [AVATAR.BEASTMAN],
        badge: RACE.CHAOS,
        range: 0,
        cost: 60,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.CHAOS_WARRIOR]: {
        MA: 5,
        ST: 4,
        AG: 3,
        PA: 3,
        AV: 9,
        normal: "GSM",
        double: "AP",
        normalCoach: "G",
        icons: ["chaos-warrior1"],
        skills: [skill_1.SKILL_NAMES.STAR],
        avatars: [AVATAR.CHAOS_WARRIOR],
        badge: RACE.CHAOS,
        range: 5,
        cost: 100,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.CHAOS_MINOTAUR]: {
        MA: 5,
        ST: 5,
        AG: 2,
        PA: 2,
        AV: 8,
        normal: "MS",
        double: "AG",
        normalCoach: "G",
        icons: ["chaos-minotaur1"],
        skills: [
            [skill_1.SKILL_NAMES.LONER, 4],
            skill_1.SKILL_NAMES.FRENZY,
            skill_1.SKILL_NAMES.HORNS,
            [skill_1.SKILL_NAMES.MIGHTY_BLOW, 1],
            skill_1.SKILL_NAMES.THICK_SKULL,
            skill_1.SKILL_NAMES.UNCHANNELLED_FURY,
            skill_1.SKILL_NAMES.BIG_GUY,
        ],
        avatars: [AVATAR.MINOTAUR],
        badge: RACE.CHAOS,
        range: 6,
        cost: 150,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    // DARK ELFE
    [CAREER_ID.DARK_ELFE_LINEMAN]: {
        MA: 6,
        ST: 3,
        AG: 4,
        PA: 4,
        AV: 8,
        normal: "GA",
        double: "SP",
        normalCoach: "G",
        icons: ["dark-elfe-lineman1"],
        skills: [],
        avatars: [AVATAR.DARK_ELF, AVATAR.ELF, AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.DARK_ELFE,
        range: 0,
        cost: 70,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.DARK_ELFE_RUNNER]: {
        MA: 7,
        ST: 3,
        AG: 4,
        PA: 4,
        AV: 7,
        normal: "GAP",
        double: "S",
        normalCoach: "G",
        icons: ["dark-elfe-runner1"],
        skills: [skill_1.SKILL_NAMES.DUMP_OFF, skill_1.SKILL_NAMES.SPECIALIST],
        avatars: [AVATAR.DARK_ELF, AVATAR.ELF, AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.DARK_ELFE,
        range: 1,
        cost: 80,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.DARK_ELFE_BLITZER]: {
        MA: 7,
        ST: 3,
        AG: 4,
        PA: 4,
        AV: 8,
        normal: "GA",
        double: "SP",
        normalCoach: "G",
        icons: ["dark-elfe-blitzer1"],
        skills: [skill_1.SKILL_NAMES.BLOCK, skill_1.SKILL_NAMES.SPECIALIST],
        avatars: [AVATAR.DARK_ELF, AVATAR.ELF, AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.DARK_ELFE,
        range: 2,
        cost: 100,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.DARK_ELFE_WITCH]: {
        MA: 7,
        ST: 3,
        AG: 4,
        PA: 4,
        AV: 7,
        normal: "GA",
        double: "SP",
        normalCoach: "G",
        icons: ["dark-elfe-witch1"],
        skills: [
            skill_1.SKILL_NAMES.STAR,
            skill_1.SKILL_NAMES.FRENZY,
            skill_1.SKILL_NAMES.DODGE,
            skill_1.SKILL_NAMES.JUMP_UP,
        ],
        avatars: [AVATAR.DARK_ELF, AVATAR.ELF, AVATAR.HUMAN, AVATAR.HUMAN_WOMAN],
        badge: RACE.DARK_ELFE,
        range: 5,
        cost: 110,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    // CHAOS DWARF
    [CAREER_ID.CHAOS_DWARF_HOBGOBELIN]: {
        MA: 6,
        ST: 3,
        AG: 3,
        PA: 3,
        AV: 7,
        normal: "G",
        double: "ASP",
        normalCoach: "G",
        icons: ["chaos-dwarf-hobgobelin1"],
        skills: [],
        avatars: [AVATAR.GOBELIN],
        badge: RACE.CHAOS_DWARF,
        range: 0,
        cost: 40,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.CHAOS_DWARF_BLOCKER]: {
        MA: 4,
        ST: 3,
        AG: 2,
        PA: 2,
        AV: 9,
        normal: "GS",
        double: "APM",
        normalCoach: "G",
        icons: ["chaos-dwarf-blocker1"],
        skills: [
            skill_1.SKILL_NAMES.BLOCK,
            skill_1.SKILL_NAMES.TACKLE,
            skill_1.SKILL_NAMES.THICK_SKULL,
            skill_1.SKILL_NAMES.SPECIALIST,
        ],
        avatars: [AVATAR.CHAOS_DWARF],
        badge: RACE.CHAOS_DWARF,
        range: 1,
        cost: 70,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.CHAOS_DWARF_BULL_CENTAUR]: {
        MA: 6,
        ST: 4,
        AG: 2,
        PA: 2,
        AV: 9,
        normal: "GS",
        double: "AP",
        normalCoach: "G",
        icons: ["chaos-dwarf-bull-centaur1"],
        skills: [
            skill_1.SKILL_NAMES.SPRINT,
            skill_1.SKILL_NAMES.SURE_FEET,
            skill_1.SKILL_NAMES.THICK_SKULL,
            skill_1.SKILL_NAMES.STAR,
        ],
        avatars: [AVATAR.CENTAUR],
        badge: RACE.CHAOS_DWARF,
        range: 5,
        cost: 130,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
    // HALFLING
    [CAREER_ID.HALFLING_LINEMAN]: {
        MA: 5,
        ST: 2,
        AG: 3,
        PA: 3,
        AV: 6,
        normal: "A",
        double: "GS",
        normalCoach: "G",
        icons: ["halfling-lineman1"],
        skills: [skill_1.SKILL_NAMES.DODGE, skill_1.SKILL_NAMES.RIGHT_STUFF, skill_1.SKILL_NAMES.STUNTY],
        avatars: [AVATAR.HALFING],
        badge: RACE.HALFLING,
        range: 0,
        cost: 30,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.HALFLING_HEFTY]: {
        MA: 5,
        ST: 2,
        AG: 3,
        PA: 3,
        AV: 7,
        normal: "AP",
        double: "GS",
        normalCoach: "G",
        icons: ["halfling-hefty1"],
        skills: [skill_1.SKILL_NAMES.DODGE, skill_1.SKILL_NAMES.FEND, skill_1.SKILL_NAMES.STUNTY],
        avatars: [AVATAR.HALFING],
        badge: RACE.HALFLING,
        range: 1,
        cost: 50,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.HALFLING_CATCHER]: {
        MA: 5,
        ST: 2,
        AG: 3,
        PA: 3,
        AV: 6,
        normal: "A",
        double: "GS",
        normalCoach: "G",
        icons: ["halfling-catcher1"],
        skills: [
            skill_1.SKILL_NAMES.CATCH,
            skill_1.SKILL_NAMES.DODGE,
            skill_1.SKILL_NAMES.RIGHT_STUFF,
            skill_1.SKILL_NAMES.SPRINT,
            skill_1.SKILL_NAMES.STUNTY,
        ],
        avatars: [AVATAR.HALFING],
        badge: RACE.HALFLING,
        range: 2,
        cost: 55,
        version: CAREER_VERSION.V6,
    },
    [CAREER_ID.HALFLING_TREEMAN]: {
        MA: 2,
        ST: 6,
        AG: 1,
        PA: 1,
        AV: 10,
        normal: "S",
        double: "AGP",
        normalCoach: "G",
        icons: ["halfling-treeman1"],
        skills: [
            skill_1.SKILL_NAMES.BIG_GUY,
            [skill_1.SKILL_NAMES.MIGHTY_BLOW, 1],
            skill_1.SKILL_NAMES.STAND_FIRM,
            skill_1.SKILL_NAMES.STRONG_ARM,
            skill_1.SKILL_NAMES.THICK_SKULL,
            skill_1.SKILL_NAMES.THROW_TEAM_MATE,
            skill_1.SKILL_NAMES.TAKE_ROOT,
        ],
        avatars: [AVATAR.TREEMAN],
        badge: RACE.HALFLING,
        range: 6,
        cost: 130,
        hasSprite: true,
        version: CAREER_VERSION.V6,
    },
};
const getCareers = () => {
    const nextCareers = (0, career2025_1.getCareers)();
    return {
        ...CAREER,
        ...nextCareers,
    };
};
exports.getCareers = getCareers;
const getAvailableCareers = () => {
    const nextCareers = (0, career2025_1.getCareers)();
    const allowedBadges = new Set(Object.values(RACE));
    return Object.entries(nextCareers).reduce((acc, [id, career]) => {
        if (allowedBadges.has(career.badge)) {
            acc[id] = career;
        }
        return acc;
    }, {});
};
exports.getAvailableCareers = getAvailableCareers;
const CAREER_IS_2025 = Object.values(CAREER_ID).reduce((acc, id) => {
    acc[id] = new Set(Object.values(career2025_1.CAREER_ID)).has(id);
    return acc;
}, {});
exports.CAREER_IS_2025 = CAREER_IS_2025;
// Migration 2025 : indique si un career legacy existe en v2025
const CAREER_MIGRATION_2025 = (() => {
    const migrated = new Set(Object.values(career2025_1.CAREER_ID));
    const map = {};
    Object.values(CAREER_ID).forEach((id) => {
        map[id] = migrated.has(id);
    });
    return map;
})();
exports.CAREER_MIGRATION_2025 = CAREER_MIGRATION_2025;
